import {Tooltip} from 'platform/components';
import {Box, Text} from 'platform/foundation';

import {useRef} from 'react';

import {suffixTestId, TestIdProps, useIsTruncated} from 'shared/web';

interface VehicleFeatureProps extends TestIdProps {
  name: string;
}

/**
 * A single vehicle feature label. Names too long for their column are clipped to one
 * line so they cannot overflow into the neighbouring column, and the full name is
 * offered in a tooltip only where it is actually clipped.
 */
export function VehicleFeature(props: VehicleFeatureProps) {
  const textRef = useRef<HTMLDivElement>(null);
  const isTruncated = useIsTruncated(textRef, props.name);

  return (
    <Tooltip label={props.name} isDisabled={!isTruncated} placement="top">
      {/* Tooltip makes its wrapper a tab stop unless a child opts out, and a vehicle
          lists dozens of features - none of them interactive. */}
      <Box tabIndex={-1}>
        <Text ref={textRef} size="small" noWrap data-testid={suffixTestId('vehicleFeature', props)}>
          {props.name}
        </Text>
      </Box>
    </Tooltip>
  );
}
